module.exports = __webpack_public_path__ + "img/tv.ea566563.svg";